<main class="container">
  <left-menu />
  <section id="column2">
    <div class="row">
      <div class="col col-12">
        <h1>Local Metal Loss</h1>
        <mat-horizontal-stepper [linear]="isLinear" #stepper labelPosition="bottom">
          <mat-step [stepControl]="firstFormGroup">
            <ng-template matStepLabel>Applicability and Limitations</ng-template>
            <form [formGroup]="firstFormGroup">
              <!-- <div class="result">
                <p [innerHTML]="applicability"></p>
              </div>
              <hr /> -->
                 <!-- new implementation by shameer-->
        <div class="result">
          <ol type="1">
            <li><tr><mat-label>The original design criteria were in accordance with a recognized code or standard.</mat-label></tr></li>
            <li><tr><mat-label>The component is not operating in the creep range. See the Help Menu for temperature limit used to define the creep range.</mat-label></tr></li>
            <li><tr><mat-label>The material is considered to have sufficient material toughness and the component is not subject to embrittlement during operation due to temperature and/or process environment.</mat-label></tr></li>
            <li><tr><mat-label>The component is not in cyclic service (i.e., less than 150 cycles in past and future planned operation or satisfying the cyclic service screening criteria).</mat-label></tr></li>
            <li> <tr>
              <mat-label>The component is within the design out-of-roundness tolerance.</mat-label>
            </tr></li>
            <li><tr><mat-label>Type A components subject to internal pressure or external pressure. Type A components have a design equation that specifically relates pressure and/or other loads to a required wall thickness.</mat-label></tr>
            <br />
            <tr><mat-label><b>Select an option for Type A Component screening :</b></mat-label>
              <button class="btn btn-primary no-arrow float-right" [disabled] = "isreevalu" (click)="typeareevaluate()" >ReEval&nbsp;<span class="icon-chevron-right"></span></button>
            </tr> 
          <!-- </li></ol> -->
          
             <!-- </div> -->
         <!-- <div class="result no-margin"> -->
          
         <ol type="a">
            <li><tr><mat-label>Pressure vessels</mat-label></tr></li>
            <!-- </div> -->
              <tr>
                <mat-radio-group [style.fontSize.px]="6" [style.padding]="3" name ="TypeA" formControlName="radio"  class="small-radio-button"  (change)="onRadioChange($event)">
                <td><mat-radio-button  matTooltip="{{ tooltipText1 }}" matTooltipClass="my-custom-tooltip mdc-tooltip__surface multiline-tooltip" name="VS" color = "primary" value ="1" style=" height: 10px; width: 10px;" class="smallRadio">Vertical Vessel</mat-radio-button></td>
                <td><mat-radio-button matTooltip="{{ tooltipText2 }}" matTooltipClass="my-custom-tooltip mdc-tooltip__surface multiline-tooltip" name="VS" color = "primary" value ="2">Horizontal Vessel</mat-radio-button></td>
                </mat-radio-group>
              </tr>
           <!-- <ol> -->
            <li><tr><mat-radio-group  name ="TypeA" color = "primary" formControlName="radio" (change)="onRadioChange($event)"><td><mat-radio-button  name="VS" value ="5"></mat-radio-button></td></mat-radio-group><mat-label>Spherical components and formed heads (elliptical, F&D, Head and torispherical)</mat-label></tr></li>
            <!-- <li><tr><mat-radio-group  name ="TypeA"  formControlName="radio" (change)="onRadioChange($event)"><td><mat-radio-button  name="VS" [value] ="6"></mat-radio-button></td></mat-radio-group><mat-label>Spherical, elliptical and torispherical formed heads </mat-label></tr></li> -->
            <li><tr><mat-label>Straight sections of piping systems and elbows or pipe bends that do not have structural attachments satisfying the size and temperature criteria </mat-label></tr></li>
              <tr>
              <mat-radio-group  name ="TypeA"  formControlName="radio"   (change)="onRadioChange($event)"  class="size:small-button">
                <td><mat-radio-button matTooltip="{{ tooltipText3 }}" matTooltipClass="my-custom-tooltip mdc-tooltip__surface multiline-tooltip" class="size:small" color = "primary" name="VS" value="3">Carbon and Low Alloy Steel</mat-radio-button></td>
                <td><mat-radio-button matTooltip="{{ tooltipText4 }}" matTooltipClass="my-custom-tooltip mdc-tooltip__surface multiline-tooltip" color = "primary" name="VS" value="4">High Alloy and Nonferrous Steel</mat-radio-button></td>
              </mat-radio-group>
              </tr>
            <li><tr><mat-radio-group color = "primary" name ="TypeA"  formControlName="radio"  (change)="onRadioChange($event)"><td><mat-radio-button  name="VS" value ="7" [disabled] ="isCylAtmradio"></mat-radio-button></td></mat-radio-group><mat-label [disabled]="isCylAtmradio" color= "primary">Cylindrical atmospheric storage tank shell courses </mat-label></tr></li>
          </ol>
        </li></ol>
      <!-- </div> -->
    </div>
    
    <hr />
              <div>
                
                <mat-checkbox
                  required
                  color = "primary"
                  formControlName="applicabilityCheckbox"
                  [ngClass]="{
                    'text-light-red':
                      firstFormGroup.controls['applicabilityCheckbox']
                        .invalid &&
                      (firstFormGroup.controls['applicabilityCheckbox'].dirty ||
                        firstFormGroup.controls['applicabilityCheckbox']
                          .touched)
                  }"
                >
                  <div class="float-left no-margin">
                    All the conditions listed above are met.
                  </div>
                  <div
                    class="text-light-red float-right no-margin"
                    *ngIf="
                      firstFormGroup.controls['applicabilityCheckbox']
                        .invalid &&
                      (firstFormGroup.controls['applicabilityCheckbox'].dirty ||
                        firstFormGroup.controls['applicabilityCheckbox']
                          .touched)
                    "
                  >
                    (Required)
                  </div>
                </mat-checkbox>
                <!-- <button
                  (click)="goToComponent()"
                  class="btn btn-primary no-arrow float-right arrow"
                >
                  Next&nbsp;
                  <span class="icon-chevron-right"></span>
                </button> -->
              </div>
            <tr></tr>
            <div>
                
              <mat-checkbox
                required
                color = "primary"
                formControlName="typeACheckbox"
                id = "CheckboxTypeA" [disabled]="isCheckboxDisabled"
                [ngClass]="{
                  'text-light-red':
                    firstFormGroup.controls['typeACheckbox']
                      .invalid &&
                    (firstFormGroup.controls['typeACheckbox'].dirty ||
                      firstFormGroup.controls['typeACheckbox']
                        .touched)
                }"
              >
                <div class="float-left no-margin">
                  Proceed with the assessment excluding Type A Component screening results.
                </div>
                <div
                  class="text-light-red float-right no-margin"
                  *ngIf="
                    firstFormGroup.controls['typeACheckbox']
                      .invalid &&
                    (firstFormGroup.controls['typeACheckbox'].dirty ||
                      firstFormGroup.controls['typeACheckbox']
                        .touched)
                  "
                >
                  (Required)
                </div>
              </mat-checkbox>
              <button
              (click)="goToComponent()"
              class="btn btn-primary no-arrow float-right arrow"
            >
              Next&nbsp;
              <span class="icon-chevron-right"></span>
            </button>
            </div>
             
            </form>
          </mat-step>
      <mat-step [completed]="isMfhMode || !!localmetalloss_formGroup.get('radioButton_DI').value">
        <ng-template matStepLabel>Type of Load</ng-template>
        <fieldset class="border rounded-3 p-3">
          <legend class="subtitle-4 float-none w-auto px-3">
            Applied Load
          </legend>
          <form [formGroup]="localmetalloss_formGroup">
            <div class="container">
              <div class="form-group row align-items-center">
                <div class="col-sm-6 align-self-center">
                  <input
                    type="radio"
                    id="radioButton1_DI"
                    name="radioButton_DI"
                    formControlName="radioButton_DI"
                    value="radioButton1_DI_enabled"
                    (change)="onChangeRadioButton1_DI($event.target.value)"
                  />
                  <label for="radioButton1_DI">&nbsp;Internal Pressure</label>
                </div>
                <div class="col-sm-6" [style.opacity]="isSphericalSelected ? '0.4' : '1'">
                  <input
                    type="radio"
                    id="radioButton2_DI"
                    name="radioButton_DI"
                    formControlName="radioButton_DI"
                    value="radioButton2_DI_enabled"
                    (change)="onChangeRadioButton1_DI($event.target.value)"
                    [disabled]="isSphericalSelected"
                  />
                  <label for="radioButton2_DI">&nbsp;External Pressure</label>
                </div>
              </div>
              <div class="text-light-red mt-2" *ngIf="showDIRequiredMessage">
                Please select Internal or External Pressure and click Next.
              </div>
            </div>
          </form>
        </fieldset>
          <button
          class="btn btn-primary no-arrow float-left"
          (click)="goPreviousStep()"
        >
          <span class="icon-chevron-left"></span>
          &nbsp;Back
        </button>
       <button
        class="btn btn-primary no-arrow float-right arrow"
        (click)="
          localmetalloss_formGroup.get('radioButton_DI').value === 'radioButton1_DI_enabled'
            ? goToMAWPComponent()
            : goToMAEPComponent()
        "
      >
        Next&nbsp;
        <span class="icon-chevron-right"></span>
      </button>
    
      </mat-step>

       <mat-step [stepControl]="secondFormGroup">
              <ng-template matStepLabel>
                {{
                  isMfhMode
                    ? 'Component MFH'
                    :
                  localmetalloss_formGroup.get('radioButton_DI').value === 'radioButton1_DI_enabled'
                    ? 'Component MAWP'
                    : localmetalloss_formGroup.get('radioButton_DI').value === 'radioButton2_DI_enabled'
                    ? 'Component MAEP'
                    : 'Component MAWP/MAEP'
                }}
              </ng-template>

              <ng-container>
                <div *ngIf="!isMfhMode && !localmetalloss_formGroup.get('radioButton_DI').value">
                  Please select Internal or External Pressure and click Next.
                </div>

                <mfh
                  *ngIf="isMfhMode"
                  #mfhComponent
                  (summaryCalculated)="handleSummaryData($event)"
                  (nextStep)="goNextStep()"
                ></mfh>
                
                <mawp
                  *ngIf="!isMfhMode && localmetalloss_formGroup.get('radioButton_DI').value === 'radioButton1_DI_enabled'"
                  #mawpComponent
                  (formDataChange)="handleFormData($event)"
                  (summaryCalculated)="handleSummaryData($event)"
                  (nextStep)="goNextStep()"
                ></mawp>

                <maep
                  *ngIf="!isMfhMode && localmetalloss_formGroup.get('radioButton_DI').value === 'radioButton2_DI_enabled'"
                  #maepComponent
                  (formDataChange)="handleFormData($event)"
                  (summaryCalculated)="handleSummaryData($event)"
                  (nextStep)="goNextStep()"
                ></maep>
              </ng-container>

              <br />
              <div>
                <button class="btn btn-primary no-arrow float-left" (click)="goPreviousStep()">
                  <span class="icon-chevron-left"></span>&nbsp;Back
                </button>      
                <button
                  class="btn btn-primary no-arrow float-right"
                  (click)="onNextClickcalculateSummary()"
                >
                  Next&nbsp;<span class="icon-chevron-right"></span>
                </button>
              </div>
          </mat-step>


          <mat-step>
            <ng-template matStepLabel>Inspection Data</ng-template>
            <inspection-data
              [MAWP_result]="summary"
              [MAEP_result]="summary"
              [isMfhMode]="isMfhMode"
              [radiobuttonDI]="localmetalloss_formGroup.get('radioButton_DI').value"
              [inspectionDataCalc]="inspectionDataCalculate"
              (inspectionDataResult)="handleInspectionData($event)"
              (nextStep)="goNextStep()"
            ></inspection-data>
            <div>
              <button
                class="btn btn-primary no-arrow float-left"
                (click)="goPreviousStep()"
              >
                <span class="icon-chevron-left"></span>
                &nbsp;Back
              </button>
              <button
                (click)="calculateResult()"
                class="btn btn-primary no-arrow float-right arrow"
              >
                Next&nbsp;
                <span class="icon-chevron-right"></span>
              </button>
            </div>
          </mat-step>

          <mat-step>
            <ng-template matStepLabel>Results</ng-template>
            <fieldset class="border rounded-3 p-3">
              <legend class="subtitle-4 float-none w-auto px-3">
                Local Metal Loss Assessment Results
              </legend>
              <div class="container">
                <div class="result">
                  <p [innerHTML]="inspectionDataResult"></p>
                </div>
              </div>
            </fieldset>
            <br />
            <div>
              <button
                class="btn btn-primary no-arrow float-left"
                (click)="goPreviousStep()"
              >
                <span class="icon-chevron-left"></span>
                &nbsp;Back
              </button>
            </div>
            <div>
              <print-report></print-report>
            </div>
          </mat-step>
        </mat-horizontal-stepper>
      </div>
    </div>
  </section>
</main>